export default __webpack_public_path__ + "static/media/open-for-job-switch.a50ccc00.svg";